export default __webpack_public_path__ + "static/media/image123.dcacb241.jpg";